export default "__VITE_ASSET__b02e60aa__"